<template>
    <div class="case">
        <div class='u810'>
            <div class='u810_content'>
                <div class='hd'>客户案例</div>
                <div class='u810_item'>
                    <div v-for='(item,index) in list' :key='index' class='u810_i'>
                        <img :src='item.url1' />
                        <img :src='item.url2' />
                    </div>
                </div>
            </div>
        </div>

        <div class='u811'>
            <div>
                <img src="../assets/m27.png">
                <div>查看详细 +</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'case',
    props: {
        list: {
            type: [String, Number],
            default: ''
        },
	},
    data() {
        return {

        }
    },
    mounted() {

    },
    methods:{

    }
}
</script>
<style scoped>
@media all and (min-width: 980px) {
    .footer2{
        display: none !important;
    }
    .footer1{
        display: block !important;
    }
    .case .u810 .u810_content{
        width: 75rem;
    }

    .case .u811 > div{
        width: 1000px !important;
    }
    .case .u811 > div > div{
        width: 180px;
        height: 58px;
        line-height: 58px;
        font-size: 18px;
        text-align: center;
    }
}
@media all and (max-width: 980px) {
    .case .u810 .u810_content{
        width: 100% !important;
    }
    .case .u811 > div{
        width: 100% !important;
    }
    .case .u811 > div > div{
        position: absolute;
        width: 140px;
        height: 44px;
        line-height: 44px;
        text-indent: 40px;
        font-size: 16px;
        right: 2%;
    }
}

</style>
<style lang="scss" scoped>
    .case{
        .u810{
            width: 100%;
            background: url(../assets/u810b.jpg) #fff no-repeat center center;
            background-size: cover;
            .u810_content{
                margin: 0 auto;
                padding-top: 64px;
                .hd{
                    text-align: center;
                    font-size: 26px;
                    color: #1e1515;
                    position: relative;
                    margin-bottom: 60px;
                }
                .hd::after{
                    content: '';
                    display: block;
                    width: 62px;
                    height: 3px;
                    background: #e81212;
                    position: absolute;
                    top: 50px;
                    left: 50%;
                    margin-left: -31px;
                }
                .u810_item{
                    display: flex;
                    flex-wrap: wrap;
                    .u810_i{
                        text-align: center;
                        background: #fff;
                        margin-bottom: 22px;
                        overflow: hidden;
                        >img:nth-of-type(1) {
                            width: 384px;
                            height: 223px;
                            transition: transform .5s linear;
                        }
                        >img:nth-of-type(1):hover{
                            transform: scale(1.1);
                            transition: transform .5s linear;
                        }
                        >img:nth-of-type(2) {
                            height: 48px;
                            width: auto;
                            text-align: center;
                            padding-top: 20px;
                        }
                    }
                    .u810_i:nth-of-type(3n) {
                        margin-right: 0;
                    }
                }
            }
        }

        .u811{
            position: relative;
            width: 100%;
            min-height: 149px;
            background: url(../assets/q9.jpg) no-repeat center 0;
            >div{
                padding-top: 23px;
                margin: 0 auto;
                display: flex;
                justify-content: space-between;
                align-items: center;
                >img{

                }
                >div{
                    color: #fff;
                    background: #e81212;
                    margin-top: 25px;
                    cursor: pointer;
                }
            }
        }
    }

</style>
<style scoped>
@media all and (min-width: 980px) {
    .omsCon1Wpr{
        padding: 86.2vh 0 6vh
    }
    .case .u810 .u810_content .u810_item .u810_i {
        width: 384px;
        margin-right: 22px;
    }
}
@media all and (max-width: 980px) {

    .u811>div>img{
        width: 90%;
    }
    .case .u810 .u810_content .u810_item .u810_i {
        width: 100%;
        margin-right: 0;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/case.vue